/**
 * Leo call-to-action labels by author intent.
 *
 * Pick the narrowest label that matches what Leo will do next.
 *
 * | Label | Context |
 * | Ask Leo | Inspector Leo spotted, utility bar, composer header, empty composer. |
 * | Use this… | Per-suggestion apply on a card (`alternate.actionLabel`). |
 * | Dismiss | Skip this finding on a suggestion card, pager row, or list item. |
 * | Ask Leo | Underline finding action bar. Opens Ask Leo on the finding. |
 * | Create more options | Single-option hover secondary. Open Ask Leo for more wording. |
 * | Enhance with Leo | Quality pane rows and performance chips when Leo has no applyable row yet. |
 * | Draft with Leo | Blank item. |
 * | Create variations | Existing item that needs a rewrite, not a blank draft. |
 */

import { verbOf } from "@/lib/objects/registry"
import "@/lib/objects/definitions"

export const LEO_ASK_LABEL = verbOf("question", "ask-leo").label

export const LEO_DISMISS_LABEL = "Dismiss"

/** Multi-option canvas hover footer. */
export const LEO_MODIFY_WITH_LEO_LABEL = "Modify with Leo"

/** Single-option hover secondary next to Apply. */
export const LEO_CREATE_MORE_OPTIONS_LABEL = "Create more options"

export const LEO_ENHANCE_WITH_LEO_LABEL = "Enhance with Leo"

export const LEO_DRAFT_WITH_LEO_LABEL = "Draft with Leo"

export const LEO_CREATE_VARIATIONS_LABEL = "Create variations"

export function leoModifyFindingAria(findingTitle: string): string {
  return `${LEO_ASK_LABEL}: ${findingTitle}`
}

export function leoCreateMoreOptionsAria(findingTitle: string): string {
  return `${LEO_CREATE_MORE_OPTIONS_LABEL}: ${findingTitle}`
}

export function leoDismissFindingAria(findingTitle: string): string {
  return `${LEO_DISMISS_LABEL}: ${findingTitle}`
}

/** Ask Leo chip after two distractor cards — Leo's next single-option guess. */
export function leoTryDistractorInsteadChip(text: string): string {
  const trimmed = text.trim()
  return trimmed ? `Try ${trimmed} instead` : ""
}

export function parseTryDistractorInsteadChip(prompt: string): string | null {
  const match = prompt.trim().match(/^Try (.+) instead$/i)
  return match?.[1]?.trim() ?? null
}
